import { render, staticRenderFns } from "./BoxList.vue?vue&type=template&id=6ecfa5f3&"
import script from "./BoxList.vue?vue&type=script&lang=js&"
export * from "./BoxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports